import ThemesController from './themes.controller';

export default {
    template: require('./themes.tpl.html'),
    controller: ThemesController
};
